
import { ProductScrapReasonModel, ScrapReasonModel, StationModel } from '@/libs/Api';
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { scrapReasonsStore } from '@/libs/scrap-reasons/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';

@Component({})
export default class ProductScrapReasonList extends Page {
    productScrapReasons: ProductScrapReasonModel[] = [];
    @Prop() workplaceId!: string;
    @Prop() inputValue!: ProductScrapReasonModel[];

    mounted() {
        if (this.inputValue) {
            this.productScrapReasons = this.inputValue;
        }
    }

    get items(): StationModel[] {
        let items: ScrapReasonModel[] = scrapReasonsStore.useGetter(CrudGetter.Data) ?? [];
        return items.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }

    isSelected(scrapReasonId: string): boolean {
        return this.productScrapReasons?.some((x) => x.scrapReasonId == scrapReasonId);
    }

    onSelectChange(scrapReasonId: string) {
        const items = [...(this.productScrapReasons ?? [])];
        if (this.isSelected(scrapReasonId)) {
            items.splice(items.indexOf(items.find((x) => x.scrapReasonId == scrapReasonId)!), 1);
        } else {
            items.push({
                scrapReasonId: scrapReasonId,
            });
        }
        this.productScrapReasons = items;
        this.$emit('change', items);
    }
}
